function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7612 7.8685L15.7803 7.89841V7.89969L15.7987 7.92833L15.8006 7.93151L15.8159 7.95888C15.8872 8.08364 15.9375 8.21476 15.9668 8.34779C16.04 8.70996 15.9954 9.05176 15.8013 9.37447C15.7605 9.5196 15.4245 9.8003 15.287 9.88177L2.25132 17.1144C2.02282 17.2411 1.76503 17.3092 1.50088 17.3092C1.07633 17.1997 0.962398 17.3123 0.539121 16.9718C0.402909 16.8604 0.290884 16.7363 0.201136 16.5867L0.199227 16.5835L0.182041 16.5543V16.553L0.164219 16.5218L0.162309 16.5174C0.0585586 16.3219 0 16.1004 0 15.8668V1.44169C0 1.19218 0.0661967 0.957306 0.18395 0.752351C0.321436 0.521299 0.484382 0.348169 0.723708 0.209411C0.951578 0.0782903 1.20618 0.00509205 1.4716 0C1.75867 0.000636507 2.00245 0.0521936 2.25387 0.192225L15.2532 7.40448C15.4652 7.52224 15.6358 7.68327 15.7612 7.86913",
  fill: "#6A6CFC"
});

function SvgPlayBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlue);
export default __webpack_public_path__ + "static/media/playBlue.069975637ebbc76839e6e9f13bd36a6ec53bd397d1cc1751ac2ce870735ef403.svg";
export { ForwardRef as ReactComponent };